import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { WithStyles, Theme, createStyles, withStyles, Menu, MenuItem } from '@material-ui/core'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import Link from 'src/shared/Link/Link'
import { CotationCriteria } from 'src/type/criteria/cotationCriteria'
import { fetchCotations } from 'src/core/redux/action/cotationsAction'
import { updateCotation, duplicateCotation } from 'src/core/redux/action/cotationAction'
import BtnIcon from 'src/shared/BtnIcon/BtnIcon'
import ItemWithModal from 'src/shared/ItemWithModal/ItemWithModal'
import { withRouter, RouteComponentProps } from 'react-router'
import {debounce} from 'lodash'


const styles = (t: Theme) => createStyles({

});

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  dispatch: any;
  entity: any;
  status: string;
  refeshAfterChange: any;
}

interface IStates {
    actionsAnchor: any;
    openedId: string | null;
    itemPerformingRequest: any;
}

class CotationsCellAction extends React.Component<IProps, IStates> {

  state = {
    actionsAnchor: null,
    openedId: null,
    itemPerformingRequest: null
  }


  render() {
    const {t, entity} = this.props
    const { itemPerformingRequest, actionsAnchor, openedId } = this.state;
    return (
        <React.Fragment>
            {entity.id &&
                <BtnIcon
                    icon="arrow_drop_down"
                    isAfter={true}
                    onClick={(e) => this.updateAnchor(e.currentTarget, entity.id)}
                    color="primary"
                    loading={itemPerformingRequest === entity.id}
                >
                    {t.actions}
                </BtnIcon>
            }

            <Menu
                open={openedId === entity.id}
                anchorEl={actionsAnchor}
                onClose={this.itemClose}
            >
                <Link to={{
                    pathname: `cotation/${entity.product_type}/${entity.id}`,
                }}>
                    <MenuItemDetail
                        labelItem={t.Cotation_table_detail}
                        onClose={this.itemClose}
                    />
                </Link>
                <MenuItemDuplicate
                    labelItem={t.Cotation_table_duplicate}
                    onDuplicate={this.duplicateCotation}
                    cancelLabel={t.cancel}
                    onClose={this.itemClose}
                    modalTilte={t.Cotation_table_duplicate_modal_title}
                    modalContent={t.Cotation_table_duplicate_modal_content}
                />
                {(entity.status === "EXPIRED" || entity.status === "LIVE") &&
                    <MenuItemReachToExpire
                        labelItem={
                            entity.status === "LIVE" ? t.Cotation_table_pass_for_expire : t.Cotation_table_pass_for_live
                        }
                        cancelLabel={t.cancel}
                        onChangeStatus={this.updateStatusCotation}
                        onClose={this.itemClose}
                        modalTilte={
                            entity.status === "LIVE" ? t.Cotation_table_pass_for_expire_modal_title : t.Cotation_table_pass_for_live_modal_title
                        }
                        modalContent={
                            entity.status === "LIVE" ? t.Cotation_table_pass_for_expire_modal_content : t.Cotation_table_pass_for_live_modal_content
                        }
                    />
                }
            </Menu>
                
        </React.Fragment>
    )
  }

    updateAnchor = (anchor, id) => {
        this.setState({
            actionsAnchor: anchor,
            openedId: id
        });
    };

    duplicateCotation = () => {
        const {entity, promisesWithProgress, toastError} = this.props
        promisesWithProgress(
            this.props.duplicate(entity.product_type, entity.id).then(res => {
                this.props.history.push({
                    pathname: `cotation-duplicate/${entity.product_type}/${res.id}`,
                    state: { 
                        duplicate: true,
                        productType: entity.product_type,
                        data: res
                    }
                })
            }).catch(err => toastError(err.msg))
        )
    }

    updateStatusCotation = () => {
        const { updateStatus, entity, promisesWithProgress, toastError, toastSuccess, t } = this.props
        promisesWithProgress(
            updateStatus({cotation: {status: entity.status === "LIVE" ? "EXPIRED" : "LIVE"}}, entity.product_type, entity.id).then(res => {
                this.refeshSuccess();
                toastSuccess(t.action_success);
            }).catch(err => toastError(err.msg))
        )
    };

    private refeshSuccess = debounce(() => {
        this.props.reFetch(this.props.criteria)
        this.props.refeshAfterChange();
    }, 1000);

    itemClose = () => {
        this.updateAnchor(null, null)
    }
 
}


interface IPropsMenuItem {
    labelItem: string;
    cancelLabel?: string;
    modalContent?: string;
    modalTilte?: string;
    onDuplicate?: any;
    onClose?: any;
    onChangeStatus?: any;
}

const MenuItemDetail: React.SFC<IPropsMenuItem> = ({onClose, labelItem}) => {
    return (
        <MenuItem
            onClick={() => onClose()}
        >
            {labelItem}
        </MenuItem>
    )
};

const MenuItemDuplicate: React.SFC<IPropsMenuItem> = ({onDuplicate, onClose, labelItem, cancelLabel, modalContent, modalTilte}) => {
    return (
        <ItemWithModal
            title={modalTilte}
            content={<div>{modalContent}</div>}
            cancelLabel={cancelLabel}
            onCancel={() => onClose()}
            onConfirm={() => {
                onDuplicate();
                onClose();
            }}
        >
            <MenuItem> {labelItem}</MenuItem>
        </ItemWithModal>
    )
};

const MenuItemReachToExpire: React.SFC<IPropsMenuItem> = ({onChangeStatus, onClose, labelItem, cancelLabel,  modalContent, modalTilte}) => {
    return (
        <ItemWithModal
            title={modalTilte}
            content={<div>{modalContent}</div>}
            cancelLabel={cancelLabel}
            onCancel={() => onClose()}
            onConfirm={() => {
                onChangeStatus();
                onClose();
            }}
        >
            <MenuItem> {labelItem}</MenuItem>
        </ItemWithModal>
    )
};

const state2props = (state: RootState) => ({
    criteria: state.paginate.cotations.criteria,
});

const dispatch2props = (dispatch: any) => ({
    duplicate: (productType: string, id: string) => dispatch(duplicateCotation(productType, id)),
    reFetch: (criteria?: CotationCriteria) => dispatch(fetchCotations(criteria)),
    updateStatus: (data: any, productType: string, id: string) => dispatch(updateCotation(data, productType, id))
});

export default compose(
    withI18n,
    withGlobalProgress,
    withToast,
    withRouter,
    withStyles(styles),
    connect(state2props, dispatch2props),
)(CotationsCellAction)



// WEBPACK FOOTER //
// ./src/page/Consumer/Cotations/CotationsCellAction.tsx